export * from './generated/supported-regions.th';
